import { render, staticRenderFns } from "./SellPoints.vue?vue&type=template&id=1f5ea232&"
import script from "./SellPoints.vue?vue&type=script&lang=js&"
export * from "./SellPoints.vue?vue&type=script&lang=js&"
import style0 from "./SellPoints.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SellPoints.vue"
export default component.exports